var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDuplicateLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31973766-253B-47C4-A8A2-A5BAB145E7B4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1-duplicate-letter-icon",
    cx: 31,
    cy: 31,
    r: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,7 C17.55,7 18.25,7.7 18.25,8.75 L18.25,8.75 L18.25,26.25 C18.25,27.3 17.55,28 16.5,28 L16.5,28 L2.5,28 C1.45,28 0.75,27.3 0.75,26.25 L0.75,26.25 L0.75,8.75 C0.75,7.7 1.45,7 2.5,7 L2.5,7 Z M23.5,0 C24.55,0 25.25,0.7 25.25,1.75 L25.25,1.75 L25.25,22.75 L21.75,22.75 L21.75,3.5 L6,3.5 L6,0 Z",
    id: "path-3-duplicate-letter-icon"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PWS-APP-duplicate-letter-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Program---Kits---Error---Duplicate-Error-duplicate-letter-icon",
    transform: "translate(-687.000000, -131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog-duplicate-letter-icon",
    transform: "translate(468.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-duplicate-letter-icon",
    transform: "translate(4.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Area-duplicate-letter-icon",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-duplicate-letter-icon",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-duplicate-letter-icon",
    transform: "translate(195.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-duplicate-letter-icon",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-duplicate-letter-icon"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask-duplicate-letter-icon-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circle-duplicate-letter-icon",
    opacity: 0.100000001,
    mask: "url(#mask-2-duplicate-letter-icon)",
    fill: "#00B5E1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box-duplicate-letter-icon-1",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2-duplicate-letter-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4-duplicate-letter-icon",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3-duplicate-letter-icon"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask-duplicate-letter-icon-2",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color-duplicate-letter-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-4-duplicate-letter-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -7.000000)",
    fill: "#00B5E1",
    id: "Box-duplicate-letter-icon-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }))))))))))))), "xs\n");
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateLetter);
export default __webpack_public_path__ + "static/media/DuplicateLetter.1fac1bc7.svg";
export { ForwardRef as ReactComponent };